// Client-generated ids for events, batches, beacons and error reports. The
// backend deduplicates retries on them, so they must be unique per record and
// stable across a record's retries - the caller mints one and reuses it.
export function randomId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
